import { render, staticRenderFns } from "./shared.vue?vue&type=template&id=49dd656a&scoped=true&"
import script from "./shared.vue?vue&type=script&lang=js&"
export * from "./shared.vue?vue&type=script&lang=js&"
import style0 from "~/components/nav/loggedIn/navBaseElem.css?vue&type=style&index=0&id=49dd656a&scoped=true&lang=css&"
import style1 from "./shared.vue?vue&type=style&index=1&id=49dd656a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dd656a",
  null
  
)

export default component.exports